export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const;

export const NORTHERN = "northern";
export const SOUTHERN = "southern";
export const DESC_PRICE = "descPrice";
export const DESC_NAME = "descName";
export const ASC_PRICE = "ascPrice";
export const ASC_NAME = "ascName";

export type Hemisphere = typeof NORTHERN | typeof SOUTHERN;
export type SortType =
  | typeof DESC_PRICE
  | typeof DESC_NAME
  | typeof ASC_PRICE
  | typeof ASC_NAME;
export type MonthName = (typeof MONTH_NAMES)[number];
export type FilterType =
  | "All"
  | "Bug"
  | "Fish"
  | "Ocean"
  | "River"
  | "Pier"
  | "Pond";
export type ScheduleFilter = "new" | "end" | "";

export interface DataItem {
  name: string;
  northernDate: string;
  southernDate: string;
  time: string;
  price: number;
  type: string;
  size: string;
  image: string;
  northStartMonth1: number;
  northStartMonth2: number;
  northEndMonth1: number;
  northEndMonth2: number;
  southStartMonth1: number;
  southStartMonth2: number;
  southEndMonth1: number;
  southEndMonth2: number;
  location: string;
}

export interface HeaderData {
  name: string;
  northernDate: string;
  southernDate: string;
  time: string;
  price: string;
  type: string;
  size: string;
  image: string;
  location: string;
}

export interface FilterControlsProps {
  hemisphere: Hemisphere;
  currentSort: SortType;
  currentMonth: MonthName | "AllMonths";
  currentFilter: FilterType;
  searchTerm: string;
  scheduleFilter: ScheduleFilter;
  onHemisphereChange: (hemisphere: Hemisphere) => void;
  onSortChange: (sortType: SortType) => void;
  onMonthChange: (month: MonthName | "AllMonths") => void;
  onFilterChange: (filterType: FilterType) => void;
  onSearchChange: (term: string) => void;
  onScheduleFilterChange: (schedule: ScheduleFilter) => void;
  showScheduleButtons: boolean;
}

export interface DataTableProps {
  data: DataItem[];
  headerData: HeaderData;
  hemisphere: Hemisphere;
  currentMonth: MonthName | "AllMonths";
  scheduleFilter: ScheduleFilter;
}
